import { FIRING_TYPE_LABELS } from './pages';

export const portal = {
  commission: {
    rate: '{rate, number, ::.00}% including 19% VAT of the purchase price, payable by the buyer',
    amount: '€{amount, number, ::.00} including 19% VAT, payable by the buyer',
    'buyer-free': 'No commission for the buyer',
    'tenant-free': 'No commission for the tenant',
    'figure-rate': '{rate, number, ::.00}% including 19% VAT of the purchase price',
    'figure-amount': '€{amount, number, ::.00} including 19% VAT',
  },
  is24: {
    vatNote:
      '{subject, select, SALE {Purchase price} other {Rent}} {treatment, select, NET_PLUS_VAT {plus} other {including}} VAT at {rate, number}%.',
    vatNoteWithoutRate:
      '{subject, select, SALE {Purchase price} other {Rent}} {treatment, select, NET_PLUS_VAT {plus} other {including}} VAT.',
    netPurchasePrice: 'Net purchase price: {amount, number, ::currency/EUR}.',
    depositAmount: '{amount, number, ::currency/EUR}',
    depositMonths: '{months, plural, one {# month of net rent} other {# months of net rent}}',
  },
  energyParagraph: {
    lead: 'Energy certificate:',
    basis: { DEMAND: 'demand certificate', CONSUMPTION: 'consumption certificate' },
    'issued-at': 'issued on {date}',
    'primary-energy-value': 'primary energy demand {value} kWh/(m²·a)',
    'energy-class': 'energy efficiency class {energyClass}',
    'year-built': 'built {year}',
    'energy-source': 'main energy source {source}',
    'firing-type': FIRING_TYPE_LABELS,
  },
  openimmo: {
    salutation: { MR: 'Mr', MRS: 'Ms' },
    facts: {
      constructionPhase: 'Construction phase: {value}',
      buildingPermission: 'Building permit: {permitted, select, true {granted} other {not granted}}',
      shortTermBuildable: 'Buildable at short notice',
      demolition: 'Demolition required',
      rentFreeMonths: 'Rent-free period: {months, plural, one {# month} other {# months}}',
      fitOutContribution: 'Fit-out contribution: {amount, number, ::currency/EUR}',
      renewalOption: 'Renewal option: {value}',
      subletting: 'Subletting: {value}',
      rentType: 'Type of rent: {value}',
    },
    constructionPhase: { PROJECTED: 'Projected', UNDER_CONSTRUCTION: 'Under construction', COMPLETED: 'Completed' },
    subletting: { ALLOWED: 'allowed', NOT_ALLOWED: 'not allowed', ON_REQUEST: 'on request' },
    rentType: { FIXED: 'Fixed rent', GRADUATED: 'Graduated rent', INDEXED: 'Index-linked rent' },
    energySource: {
      NATURAL_GAS_LIGHT: 'Light natural gas',
      NATURAL_GAS_HEAVY: 'Heavy natural gas',
      DISTRICT_STEAM: 'District steam',
      LOCAL_HEAT: 'Local heat',
      HEAT_DELIVERY: 'Heat delivery',
      BIOENERGY: 'Bioenergy',
      WIND_ENERGY: 'Wind energy',
      WATER_ENERGY: 'Water energy',
      ENVIRONMENTAL_HEAT: 'Environmental heat',
    },
  },
};
